// extracted by mini-css-extract-plugin
module.exports = {"title":"NavBar_title__ce9R0","activelink":"NavBar_activelink__3QzlS","navBar":"NavBar_navBar__30vnS"};